import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getCustomizedResultsSettings } from '@user/store/globalSearch/api'
import { useEffect, useState } from 'react'

export type statusType = 'idle' | 'pending' | 'success' | 'fail'

export function useGetCustomizedResultsSettings() {
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<statusType>('idle')

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        setStatus('pending')
        const result = await dispatch(getCustomizedResultsSettings())

        if (mounted) {
          if (getCustomizedResultsSettings.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch (error) {
        if (mounted) {
          setStatus('fail')
        }
      } finally {
        if (mounted) setStatus('idle')
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return status
}
